import Script from 'next/script';

import { useScript } from '@/hooks/useScript';

const ScriptProvider = () => {
  useScript('https://www.googletagmanager.com/gtag/js?id=G-3Z1XHKWC0V');
  useScript('https://my.hellobar.com/e7c0df0267ad788d4fd91c68c2c8090c79c68f06.js');
  useScript('https://tools.luckyorange.com/core/lo.js?site-id=86bf8383', { id: 'lucky-orange' });
  return (
    <>
      <Script
        strategy='afterInteractive'
        id='google-tag-manager'
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-3Z1XHKWC0V');
          `,
        }}
      />
      <Script
        strategy='afterInteractive'
        id='facebook-pixel-code'
        dangerouslySetInnerHTML={{
          __html: ` !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '278281391494645');
        fbq('track', 'PageView');`,
        }}
      />
      <Script
        strategy='afterInteractive'
        id='linkedin-data-partner'
        dangerouslySetInnerHTML={{
          __html: ` _linkedin_partner_id = "4512218";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);`,
        }}
      />
      <Script
        id='linkedin-insight-tag'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `(function(l) {
          if (!l) {
            window.lintrk = function(a, b) {
              window.lintrk.q.push([a, b]);
            };
            window.lintrk.q = [];
          }
          var s = document.getElementsByTagName("script")[0];
          var b = document.createElement("script");
          b.type = "text/javascript";
          b.async = true;
          b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b, s);
        })(window.lintrk);`,
        }}
      />
      <Script
        strategy='afterInteractive'
        id='google-analytics'
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-KJ47RWN');`,
        }}
      />
      <Script
        id='tiktok-pixel'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: ` !function (w, d, t) {
              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
              ttq.load('CDMMNGBC77U9BMO6VGF0');
              ttq.page();
            }(window, document, 'ttq');`,
        }}
      />
      <Script
        id='twitter-conversation'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `!function(e,t,n,s,u,a){e.twq||
            (s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
            },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
            a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
            twq('config','ocsmx');`,
        }}
      />
    </>
  );
};

export default ScriptProvider;
